import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { genericDelete } from '../../services/api.service';


function Cross({ x1, y1 }: { x1: number, y1: number }) {

    return (
        <g>
            <line x1={x1} y1={y1} x2={x1 + 10} y2={y1 + 10} stroke="red" stroke-width="2" />
            <line x1={x1} y1={y1 + 10} x2={x1 + 10} y2={y1} stroke="red" stroke-width="2" />
        </g>
    )

}


export function MaquinasBars({ entregaIdx, maquinas, maquinasTimelines, yScale, setDraggedBar, maquinasBarHeight }: any) {

    const paddingY = 4;

    const [deletedMaquinas, setDeletedMaquinas] = useState<number[]>([]);

    const [textHovered, setTextHovered] = useState<number | null>(null);

    const onMouseDown = (e: any, idx: number, border: string, maquinaGanttId: string) => {
        setDraggedBar({ entrega: entregaIdx, maquina: idx, border, maquinaGanttId: maquinaGanttId });
    }

    const deleteMutation = useMutation(genericDelete(`/obras/maquinas-gantt`),
    {
        onSuccess: (data: any) => {
            toast.success("Barra-Máquina eliminada com sucesso!")
        }, onError: () => {
            toast.error("Erro ao eliminar barra-máquina!")
        }
    })


    return (<>
        {maquinas.map((maquinaGantt: any, idx: number) => {

            const barHeight = (maquinasBarHeight) - paddingY * 2;
            const yIdx = maquinaGantt.maquina.id

            return (<g key={maquinaGantt.id} className={deletedMaquinas.includes(maquinaGantt.id) ? 'hidden' : ''}>
                <rect
                    className={"fill-cyan-700 opacity-80 z-40 "}
                    x={maquinasTimelines[idx].start}
                    y={yScale(yIdx) + paddingY}
                    width={maquinasTimelines[idx].end - maquinasTimelines[idx].start}
                    height={barHeight}
                    rx={5}
                    ry={5}
                />

                <rect
                    className="fill-rodrimaq-red opacity-80 cursor-pointer hover:fill-rodrimaq-red-light  z-50"
                    x={maquinasTimelines[idx].start}
                    y={yScale(yIdx) + paddingY}
                    width={10}
                    height={barHeight}
                    rx={5}
                    ry={5}
                    onMouseDown={(e: any) => onMouseDown(e, idx, 'start', maquinaGantt.id)}
                />

                <rect
                    className="fill-rodrimaq-red opacity-80 cursor-pointer hover:fill-rodrimaq-red-light z-50"
                    x={maquinasTimelines[idx].end - 10}
                    y={yScale(yIdx) + paddingY}
                    width={10}
                    height={barHeight}
                    rx={5}
                    ry={5}
                    onMouseDown={(e: any) => onMouseDown(e, idx, 'end', maquinaGantt.id)}
                />
                <g
                    onMouseEnter={() => setTextHovered(idx)}
                    onMouseLeave={() => setTextHovered(null)}
                    onClick={async ()=> {
                        try {
                            await deleteMutation.mutate(maquinaGantt.id);
                            // const updatedMaquinas = maquinasGantt.filter((maquina: any) => maquina.id !== maquinaGantt.id);
                            setDeletedMaquinas([...deletedMaquinas, maquinaGantt.id])
                        } catch(e){
                            console.log("Error deleting maquinaGantt: ", e);
                        }
                    }}
                >
                    <text
                        className="text-sm font-bold fill-white hover:fill-zinc-300 cursor-pointer" x={maquinasTimelines[idx].start + 20} y={yScale(yIdx) + barHeight / 2 + 8}>{maquinaGantt.maquina.ref}</text>
                    {textHovered === idx ? <Cross x1={maquinasTimelines[idx].start + 15} y1={yScale(yIdx) + barHeight / 2} /> : null}
                </g>
            </g>
            )

        })}
    </>)

}